<template>
  <div class="order-query-page">
    <!-- 页面顶部背景色 -->
    <div class="page-top-bg"></div>

    <!-- 页面顶部渐变背景 -->
    <div class="page-gradient-bg"></div>

    <!-- 步骤指示器 -->
    <div class="navbar">
      <img :src="navbarImg" alt="步骤指示器" class="navbar-img" />
    </div>

    <!-- 卡片容器 -->
    <div class="card-container">
      <!-- 卡片顶部渐变色装饰条(绝对定位,不占空间) -->
      <div class="card-gradient-bar"></div>

      <!-- 内容区域 -->
      <div class="content">
        <!-- 标题和说明 -->
        <div class="section-header">
          <div class="title-decoration">
            <span class="orange-line"></span>
            <span class="section-title">订单查询</span>
          </div>
          <p class="description">输入设备SN,查询对应交易订单及风险冻结信息</p>
        </div>

        <!-- 输入框 -->
        <div class="input-wrapper">
          <input
            v-model="snCode"
            type="text"
            placeholder="请输入设备SN开始查询"
            class="sn-input"
          />
          <img
            :src="scanIcon"
            alt="扫描"
            class="scan-icon"
            @click="handleScan"
          />
        </div>

        <!-- 查询按钮 -->
        <div class="query-btn" @click="handleQuery">查询订单</div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { getAuthInfo, queryOrder } from "@/api/common";

export default {
  name: "OrderQuery",
  data() {
    return {
      snCode: "",
      loading: false, // 加载状态
      navbarImg: require("../../assets/order/navbar1.png"),
      scanIcon: require("../../assets/order/scan-icon.png"),
    };
  },
  methods: {
    // 点击扫描图标
    async handleScan() {
      // 防止重复点击
      if (this.loading) {
        return;
      }

      try {
        // 显示加载中
        this.loading = true;
        const loadingToast = this.$toast.loading({
          message: "授权中...",
          forbidClick: true,
          duration: 0,
        });

        // 调用微信JSSDK授权接口
        const res = await getAuthInfo({ urlType: 1 });
        console.log("授权信息:", res);

        // 关闭loading toast
        loadingToast.clear();

        // 配置微信JSSDK
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ["scanQRCode"],
        });

        // 等待配置完成后执行扫码
        wx.ready(() => {
          console.log("微信JSSDK配置成功，开始扫码");
          wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: (result) => {
              console.log("扫码成功:", result);
              // 扫码结果填充到输入框
              let barCode = result.resultStr.split(",");
              this.snCode = barCode[barCode.length - 1];
            },
            fail: (err) => {
              console.error("扫码失败:", err);
              this.$toast.fail("扫码失败，请重试");
            },
          });
        });

        wx.error((err) => {
          console.error("微信授权失败:", err);
          this.$toast.fail("微信授权失败，请检查网络后重试");
        });
      } catch (error) {
        console.error("获取授权信息失败:", error);
        this.$toast.fail(error.message || "获取授权信息失败");
      } finally {
        // 关闭加载状态
        this.loading = false;
      }
    },

    // 点击查询订单按钮
    async handleQuery() {
      // 防止重复点击
      if (this.loading) {
        return;
      }

      // 验证是否输入设备SN
      if (!this.snCode || this.snCode.trim() === "") {
        this.$toast("请输入设备SN");
        return;
      }

      try {
        // 显示加载中
        this.loading = true;
        const loadingToast = this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0, // 不自动关闭
        });

        // 调用查询接口
        const res = await queryOrder({ sn: this.snCode.trim() });

        console.log("查询订单响应:", res);

        // 判断是否查询到订单信息
        // 如果res为undefined，说明未查询到订单
        if (!res) {
          // 关闭loading toast
          loadingToast.clear();
          // 未查询到订单信息
          this.$toast("未查询到订单信息");
          return;
        }

        // 查询成功，关闭loading toast后跳转
        loadingToast.clear();
        this.$router.push({
          path: "/orderDetail",
          query: {
            snCode: res.snCode,
            cardNo: res.cardNo,
            transAmount: res.transAmount,
            customAddRateRealAmount: res.customAddRateRealAmount,
            orderId: res.orderId,
            transTime: res.transTime,
            merId: res.merId,
          },
        });
      } catch (error) {
        // 错误已全局处理，这里可以添加额外的错误处理逻辑
        console.error("查询订单失败:", error);
        this.$toast.fail(error.message);
      } finally {
        // 关闭加载状态
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.order-query-page {
  min-height: 100vh;
  background-color: #f5f6fa;
  padding-bottom: 40px;
}

// 页面顶部背景色
.page-top-bg {
  width: 100%;
  height: 222px;
  background-color: #fff5e2;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

// 页面顶部渐变背景
.page-gradient-bg {
  width: 100%;
  height: 150px;
  background: linear-gradient(180deg, #fff5e2 0%, rgba(255, 245, 226, 0) 100%);
  position: absolute;
  top: 222px;
  left: 0;
  z-index: 0;
}

// 步骤指示器
.navbar {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 54px; // 距离顶部54px
  padding-bottom: 0;
  position: relative;
  z-index: 1;

  .navbar-img {
    width: 486px;
    height: 114px;
  }
}

// 卡片顶部渐变色装饰条
.card-gradient-bar {
  width: 100%;
  height: 116px;
  background: linear-gradient(
    180deg,
    rgba(254, 216, 157, 0.2) 0%,
    rgba(254, 216, 157, 0) 100%
  );
  border-radius: 22px 22px 0px 0px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

// 卡片容器
.card-container {
  width: 686px;
  margin: 54px auto 0; // 距离进度条54px
  background: #fff;
  border-radius: 24px 24px 24px 24px;
  padding: 40px 22px;
  box-sizing: border-box;
  position: relative;
}

// 内容区域
.content {
  .section-header {
    margin-bottom: 30px;

    .title-decoration {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .orange-line {
        width: 8px;
        height: 30px;
        border-radius: 4px;
        background-color: #865d14;
        margin-right: 12px;
      }

      .section-title {
        font-size: 36px;
        font-weight: 700;
        color: #3d3d3d;
      }
    }

    .description {
      font-size: 24px;
      color: #666666;
      margin: 0;
      line-height: 1.5;
    }
  }

  // 输入框
  .input-wrapper {
    position: relative;
    width: 642px;
    height: 96px;
    margin: 0 auto 48px; // 距离按钮48px
    background: #f5f6fa;
    border-radius: 16px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;

    .sn-input {
      flex: 1;
      height: 100%;
      border: none;
      outline: none;
      background: transparent;
      font-size: 28px;
      color: #333;

      &::placeholder {
        color: #999;
        font-size: 28px;
      }
    }

    .scan-icon {
      width: 40px;
      height: 40px;
      cursor: pointer;
      margin-left: 16px;
    }
  }

  // 查询按钮
  .query-btn {
    width: 642px;
    height: 96px;
    margin: 0 auto;
    background-color: #fed89d;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #865d14;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.3s;

    &:active {
      opacity: 0.8;
    }
  }
}
</style>
